var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormGroup, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
export var DELETE = 'd';
export var CREATE = 'c';
export var UPDATE = 'u';
var DwDataRow = /** @class */ (function (_super) {
    __extends(DwDataRow, _super);
    function DwDataRow(datasource) {
        var _this = this;
        var controls = {};
        Object.keys(datasource).forEach(function (controlName) {
            controls[controlName] = new FormControl(datasource[controlName]);
        });
        _this = _super.call(this, controls) || this;
        _this.modifyState = '';
        _this.childs = {};
        return _this;
    }
    Object.defineProperty(DwDataRow.prototype, "$state", {
        get: function () {
            return this.modifyState;
        },
        enumerable: true,
        configurable: true
    });
    DwDataRow.prototype.addChild = function (name, table) {
        this.childs[name] = table;
    };
    DwDataRow.prototype.addChildRow = function (name, row) {
        if (!this.childs[name]) {
            this.childs[name] = [];
        }
        this.childs[name].push(row);
    };
    DwDataRow.prototype.markAsDirty = function () {
        if (this.modifyState === '') {
            this.markAsUpdate();
        }
        _super.prototype.markAsDirty.call(this);
    };
    DwDataRow.prototype.markAsPristine = function () {
        if (this.modifyState === UPDATE) {
            this.modifyState = '';
        }
        _super.prototype.markAsPristine.call(this);
    };
    DwDataRow.prototype.markAsDelete = function () {
        this.modifyState = DELETE;
    };
    DwDataRow.prototype.markAsCreate = function () {
        this.modifyState = CREATE;
    };
    DwDataRow.prototype.markAsUpdate = function () {
        this.modifyState = UPDATE;
    };
    Object.defineProperty(DwDataRow.prototype, "active", {
        get: function () {
            return (this.modifyState !== DELETE);
        },
        enumerable: true,
        configurable: true
    });
    DwDataRow.prototype.getRawValue = function () {
        var raw = _super.prototype.getRawValue.call(this);
        raw['$state'] = this.modifyState;
        if ('child' in raw) {
            delete raw.child;
        }
        Object.keys(raw).forEach(function (rawKey) {
            if (raw[rawKey] instanceof Date) {
                raw[rawKey] = (new DatePipe('zh_tw')).transform(raw[rawKey], 'yyyy/MM/dd HH:mm:ss');
            }
        });
        return raw;
    };
    return DwDataRow;
}(FormGroup));
export { DwDataRow };
